var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer footer--with-back",class:_vm.footerWrapperClass},[_c('button',{staticClass:"footer__btn-main",class:_vm.footerBtnClass,attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.buttonText))]),_c('span',{staticClass:"footer__link",on:{"click":_vm.delayedGoBack}},[_vm._v(_vm._s(_vm.$t('message["general.form-go-back"]')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }